import { CUSTOM_CONSTANTS } from './config';
import { EncryptionService } from '../services/app-services/encryption.service';

export class Cookie {
    /**
     *
     * @param cname
     * @param cvalue
     * @param ex
     */
    static set(cname: string, cvalue: any, ex?: any) {
        const encryptedUser = EncryptionService.encrypt(cvalue);
        const date = new Date();
        date.setTime(date.getTime() + ex.expires * 24 * 60 * 60 * 1000);
        const expires = 'expires=' + date.toUTCString();
        const cookies = cname + '=' + encryptedUser + ';' + expires + ';path=/';
        document.cookie = cookies;
    }

    /**
     *
     * @param cname
     */
    static remove(cname: string) {
        if (typeof Storage !== 'undefined') {
            const d = new Date();
            d.setTime(d.getTime() - 12 * 24 * 60 * 60 * 1000000);
            const expires = 'expires=' + d.toUTCString();
            document.cookie = cname + '=' + undefined + ';' + expires + ';path=/';
        }
    }

    /**
     *
     * @param cname
     */
    // tslint:disable-next-line: member-ordering
    static get(cname: string) {
        if (
            cname === CUSTOM_CONSTANTS.APP_VARIABLE &&
            !EncryptionService.decrypt(
                Cookie.prototype.prepareGet(CUSTOM_CONSTANTS.APP_VARIABLE)
            )
        ) {
            return null;
        }
        return EncryptionService.jwtDecrypt(
            EncryptionService.decrypt(Cookie.prototype.prepareGet(cname))
        );
        // return Cookie.prototype.prepareGet(cname)
    }

    static getToken() {
        if (!Cookie.prototype.prepareGet(CUSTOM_CONSTANTS.APP_VARIABLE)) {
            return null;
        }
        return EncryptionService.decrypt(
            Cookie.prototype.prepareGet(CUSTOM_CONSTANTS.APP_VARIABLE)
        );
        // return Cookie.prototype.prepareGet('appName');
    }

    /**
     *
     * @param cname
     */
    private prepareGet(cname: string) {
        if (typeof Storage !== 'undefined') {
            const name = cname + '=';
            const decodedCookie = decodeURIComponent(document.cookie);
            const ca = decodedCookie.split(';');
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length) || undefined;
                }
            }
            return '';
        } else {
            return 0;
        }
    }
}
